import { cn } from '@/utils/cn';

/**
 * Container for the main content of a roleplay card, including description
 * and scorecard. Applies consistent styling and optional fade-in animation.
 */
export const RoleplayCardContentContainer: React.FC<{
  children?: React.ReactNode;
  className?: string;
  /** Whether to apply a fade-in animation when the component mounts. */
  animateIn?: boolean;
  /** Index used to stagger animations when multiple cards are rendered in a list. */
  animationIndex?: number;
}> = ({ children, className, animateIn = false, animationIndex = 0, ...props }) => {
  const classNames = cn(
    'w-full rounded-lg bg-neutral-gray-000 p-4 md:p-6',
    animateIn && 'animate-fade-in-down animate-duration-fast',
    className,
  );

  const styles = {
    animationDelay: animationIndex > 0 && animateIn ? `${animationIndex * 100}ms` : undefined,
  };

  return (
    <div className={classNames} style={styles} {...props}>
      {children}
    </div>
  );
};

RoleplayCardContentContainer.displayName = 'RoleplayCardContentContainer';

export default RoleplayCardContentContainer;
